document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.product-tabs').forEach((tabs) => {

        const nav = tabs.querySelector('.product-tabs__nav');
        const buttons = tabs.querySelectorAll('.product-tabs__button');
        const slider = tabs.querySelector('.product-tabs__slider');
        const viewport = tabs.querySelector('.product-tabs__viewport');
        const panels = tabs.querySelectorAll('.product-tabs__panel');

        if (!slider || !nav || !viewport || !buttons.length || !panels.length) return;

        // Initial state: no tab active
        buttons.forEach((button) => {
            button.classList.remove('active');
            button.setAttribute('aria-selected', 'false');
        });

        // Hide content initially
        viewport.style.display = 'none';
        viewport.style.height = '';

        // Set viewport height to the active panel
        const updateHeight = (index) => {
            const panel = panels[index];

            if (!panel) return;

            requestAnimationFrame(() => {
                viewport.style.height = `${panel.scrollHeight}px`;
            });
        };

        buttons.forEach((button) => {

            button.addEventListener('click', () => {

                const index = Number(button.dataset.index);

                // MOBILE ONLY:
                // Clicking the already active tab closes it
                if (
                    window.matchMedia('(max-width: 767px)').matches &&
                    button.classList.contains('active')
                ) {
                    button.classList.remove('active');
                    button.setAttribute('aria-selected', 'false');

                    viewport.style.display = 'none';
                    viewport.style.height = '';

                    return;
                }

                // Show the content area
                viewport.style.display = '';

                // Update active tab
                buttons.forEach((btn) => {
                    btn.classList.remove('active');
                    btn.setAttribute('aria-selected', 'false');
                });

                button.classList.add('active');
                button.setAttribute('aria-selected', 'true');

                // Move content slider
                slider.style.transform = `translateX(-${index * 100}%)`;

                // Set height to current panel only
                updateHeight(index);

                // Center the clicked tab
                const scrollLeft =
                    button.offsetLeft -
                    (nav.clientWidth / 2) +
                    (button.clientWidth / 2);

                nav.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                });

            });

        });

        // Recalculate height if the window changes size
        window.addEventListener('resize', () => {

            const activeButton = tabs.querySelector('.product-tabs__button.active');

            if (!activeButton) return;

            const index = Number(activeButton.dataset.index);

            if (viewport.style.display !== 'none') {
                updateHeight(index);
            }

        });

    });

});